import changePasswordModalTemplate from './change-password-modal.html';

class ChangePasswordModalController {
  static $inject = ['$scope', 'Member'];

  modalInstance: any;
  oldPassword: string;
  newPassword: string;
  oldPasswordError: string;
  error: string;
  status = {
    opened: false,
  };

  constructor(
    private $scope,
    private Member,
  ) {
    this.$scope.$watch(
      () => this.oldPassword,
      () => (this.oldPasswordError = undefined),
    );
  }

  ok() {
    this.error = undefined;

    this.Member.changePassword(this.oldPassword, this.newPassword).then(
      () => {
        this.modalInstance.close();
      },
      (err) => {
        if (err.data.message === 'Invalid oldPassword') {
          this.oldPasswordError = 'Le mot de passe est invalide';
        } else {
          this.error = err.data.message;
        }
      },
    );
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  open() {
    this.status.opened = true;
  }
}

export const ChangePasswordModalComponent = {
  template: changePasswordModalTemplate,
  bindings: {
    modalInstance: '<',
  },
  controller: ChangePasswordModalController,
};
